import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, cloneElement, createElement } from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import { cleanChildren } from '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Flex from '../Flex/index.esm.js';
import Tooltip from '../Tooltip/index.esm.js';

var ButtonGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var attached = props.attached,
      fullWidth = props.fullWidth,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? true : _props$inline,
      _props$space = props.space,
      space = _props$space === void 0 ? inline ? 'space-x-4' : 'space-y-2' : _props$space,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? inline ? 'items-center' : undefined : _props$alignItems,
      _props$flexDirection = props.flexDirection,
      flexDirection = _props$flexDirection === void 0 ? inline ? 'flex-row' : 'flex-col' : _props$flexDirection,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["attached", "fullWidth", "inline", "space", "alignItems", "flexDirection", "children"]);

  var validChildren = cleanChildren(children);

  var getBorderRadius = function getBorderRadius(index) {
    var isFirst = index === 0;
    var isLast = index === validChildren.length - 1;

    if (!attached || validChildren.length === 1) {
      return undefined;
    }

    if (isFirst) {
      return {
        borderRadius: inline ? 'rounded-l-md' : 'rounded-t-md'
      };
    }

    if (isLast) {
      return {
        borderRadius: inline ? 'rounded-r-md' : 'rounded-b-md'
      };
    }

    if (!isFirst && !isLast) {
      return {
        borderRadius: 'rounded-none'
      };
    }

    return undefined;
  };

  var clones = validChildren.map(function (child, index) {
    var buttonProps = _extends({
      zIndex: 'focus:z-10'
    }, getBorderRadius(index));

    if (fullWidth && typeof fullWidth === 'boolean') {
      buttonProps.fullWidth = fullWidth;
    } // If the child is a tooltip, then we need to modify the child button


    if (child.type === Tooltip) {
      var button = cloneElement(child.props.children, _extends({}, child.props.children.props, buttonProps));
      return cloneElement(child, _extends({}, child.props, {
        children: button
      }));
    }

    return cloneElement(child, _extends({}, buttonProps, child.props));
  });
  var attachedSpacing = inline ? '-space-x-px' : '-space-y-px';
  return createElement(Flex, _extends({
    ref: ref,
    display: "inline-flex",
    flexDirection: flexDirection,
    alignItems: alignItems,
    space: attached ? attachedSpacing : space
  }, rest), clones);
});

if (__DEV__) {
  ButtonGroup.displayName = 'ButtonGroup';
}

export default ButtonGroup;
//# sourceMappingURL=index.esm.js.map
